import { z } from 'zod';

import { AbstractMeasurement } from './AbstractMeasurement';

const units = ['K'] as const;
const unit = z.literal('K').default('K');

const validator = AbstractMeasurement.minMax
    .extend({
        unit,
    })
    .default({});

const valueValidator = AbstractMeasurement.value
    .extend({
        unit,
    })
    .default({});

export const Temperature = {
    validator,
    validators: {
        value: valueValidator,
        unit,
    },
    units,
};
